/**
 * Company particulars quoted by every legal document.
 *
 * Fields marked "to be confirmed" are placeholders: legal / management must
 * fill them in before these documents are relied on in production.
 */
export const LEGAL_COMPANY = {
  entity: 'FinminOS Private Limited',
  brand: 'FinMin',
  website: 'https://finmin.co',
  customerApp: 'https://customer.finmin.co',
  registeredOffice: '[Registered office address — to be confirmed]',
  cin: '[CIN — to be confirmed]',
  supportEmail: 'admin@finminos.com',
  grievanceOfficer: '[Name — to be confirmed]',
  grievanceEmail: '[grievance email — to be confirmed]',
  /** City whose courts have jurisdiction and where arbitration is seated. */
  jurisdictionCity: '[City — to be confirmed]',
  lastUpdated: '20 October 2026',
} as const;
